import React from "react";
import { motion } from "framer-motion";
import PageHero from "@/components/PageHero";
import PartnerLeadForm from "@/components/PartnerLeadForm";
import { HERO_IMAGES } from "@/data/heroImages";
import { Trophy, Network, Lightbulb, Handshake } from "lucide-react";

const PERKS = [
  { icon: Network, title: "Accès à un vivier de talents", desc: "Étudiants opérationnels, stagiaires, alternants, jeunes diplômés." },
  { icon: Lightbulb, title: "Projets sur-mesure", desc: "Confiez de vrais défis business à nos étudiants : étude de marché, prototype, plan d'action." },
  { icon: Handshake, title: "Visibilité ciblée", desc: "Sponsoring d'événements, conférences, animations sur le campus." },
  { icon: Trophy, title: "Co-construction académique", desc: "Chaires d'entreprise, modules co-conçus, learning expéditions." },
];

export default function PartenairesPage() {
  return (
    <>
      <PageHero
        eyebrow="Espace Entreprises"
        title="Construisons ensemble"
        italicWord="l'avenir."
        subtitle="Recrutement, partenariats académiques, projets, sponsoring : quatre manières de collaborer avec ECL Campus Abidjan pour faire émerger les leaders dont vos équipes ont besoin."
        crumb="Partenaires"
        image={HERO_IMAGES.partenaires}
      />

      <section className="section-padding bg-white">
        <div className="container-edge">
          <div className="max-w-3xl mb-12">
            <div className="overline mb-4">Pourquoi nous rejoindre</div>
            <h2 className="font-display text-3xl md:text-5xl text-navy-700 leading-tight">
              Une école <em className="not-italic red-shine">au plus près</em> du terrain.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-navy-100 border border-navy-100 mb-16">
            {PERKS.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="bg-white p-8 group"
                  data-testid={`partenaire-perk-${i}`}
                >
                  <Icon className="h-9 w-9 text-navy-500 mb-5 transition-transform group-hover:scale-110" strokeWidth={1.4} />
                  <h3 className="font-display text-xl text-navy-700 mb-3">{p.title}</h3>
                  <p className="text-[#555] text-[14px] leading-relaxed">{p.desc}</p>
                </motion.div>
              );
            })}
          </div>

          <div className="max-w-3xl mx-auto">
            <PartnerLeadForm />
          </div>
        </div>
      </section>
    </>
  );
}
